import { DeleteOutline } from "@mui/icons-material";
import { Chip, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid-premium";
import moment from "moment";
import { DATE_TIME_FORMAT } from "../../components";

// TODO: Requires Tag canonical name changes
export const DashboardTableColumn = (arg: { onDelete?: any, view?: any, hideDelete?: boolean, getPath: (id: string) => string }) => {

    const {
        onDelete = (row: any) => false,
        view = (row: any) => false,
        hideDelete = true,
        getPath
    } = arg;

    const columns: GridColDef[] = [
        {
            field: 'sequence_id', headerName: 'Task ID', width: 120, renderCell: (params: GridRenderCellParams) => {
                if (params.rowNode.type === 'group') {
                    return params.value;
                }
                return (
                    <Stack direction="row" spacing={1} sx={{
                        alignItems: "center"
                    }}>
                        <Typography
                            id="view-task"
                            component={"a"}
                            href={getPath(params.row?._id)}
                            onClick={(e) => {
                                e.preventDefault();
                                view(params.row);
                            }}
                            variant="body2"
                            color="primary"
                            sx={{ cursor: "pointer", textDecoration: "underline" }}>
                            {params.row.sequence_id}
                        </Typography>
                    </Stack>
                );
            }
        },
        { field: 'name', headerName: 'Task Name', width: 200 },
        {
            field: 'description', headerName: 'Task Description', width: 200, renderCell: (params: GridRenderCellParams) => {
                if (params.rowNode.type === 'group') {
                    return params.value;
                }
                return <Tooltip title={params.row.description}>
                    <Typography variant="body2" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                        {params.row.description}
                    </Typography>
                </Tooltip>
            }
        },
        {
            field: 'deadline', headerName: 'Deadline', width: 250, renderCell: (params: GridRenderCellParams) => {
                if (params.rowNode.type === 'group') {
                    return params.value;
                }
                return <Typography variant="body2">{moment(params.row.deadline).format(DATE_TIME_FORMAT)}</Typography>
            }
        },
        {
            field: 'closed', headerName: 'Is Closed?', width: 120, renderCell: (params: GridRenderCellParams) => {
                if (params.rowNode.type === 'group') {
                    return params.value;
                }
                return (
                    <Stack width={"100%"}>
                        {params.row.closed && <Chip size="small" color="error" label={"Closed"} />}
                        {!params.row.closed && <Chip size="small"  color="success" label={"Open"} />}
                    </Stack>
                )
            },
            valueGetter: (value, row, column, apiRef) => row?.closed ? "Closed" : "Open",
        },
        { field: 'hours_estimated', headerName: 'Estimated Hours', width: 140 },
        { field: 'hours_spent', headerName: 'Spent Hours', width: 130 },
        // {
        //     field: 'Task Type', headerName: 'Task Type', width: 150,
        //     valueGetter: (value, row, column, apiRef) => { return row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.task_type)?.[0]?.tag_name ?? "" },
        //     renderCell: (params: GridRenderCellParams) => {
        //         if (params.rowNode.type === 'group') {
        //             if (params.rowNode.groupingField === 'Task Type') {
        //                 return params.rowNode.groupingKey;
        //             }
        //             return '';
        //         }
        //         return (
        //             <Stack
        //                 spacing={1}
        //                 direction={"row"}
        //                 id={"tagsChip"}
        //                 sx={{
        //                     width: "100%",
        //                 }}>
        //                 {params.row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.task_type).map((tag: any) => <Chip key={tag.tag_group_id} variant="outlined" sx={{ borderColor: tag.tag_group_color, backgroundColor: tag.tag_group_color, color: `${hexToGrayscale(tag.tag_group_color) > 150 ? "rgba(0, 0, 0, 0.87)" : "#FFFFFF"}` }} size={"small"} label={tag?.tag_name ?? ""} />)}
        //             </Stack>
        //         );
        //     },
        //     groupingValueGetter: (value, row, column, apiRef) => {
        //         return row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.task_type)?.[0]?.tag_name ?? "";
        //     },
        //     disableColumnMenu: true,
        //     sortable: false,
        // },
        // {
        //     field: 'Category', headerName: 'Category', width: 150,
        //     valueGetter: (value, row, column, apiRef) => { return row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.task_category)?.[0]?.tag_name ?? "" },
        //     renderCell: (params: GridRenderCellParams) => {
        //         if (params.rowNode.type === 'group') {
        //             if (params.rowNode.groupingField === 'Category') {
        //                 return params.rowNode.groupingKey;
        //             }
        //             return '';
        //         }
        //         return (
        //             <Stack
        //                 spacing={1}
        //                 direction={"row"}
        //                 id={"tagsChip"}
        //                 sx={{
        //                     width: "100%",
        //                 }}>
        //                 {params.row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.task_category).map((tag: any) => <Chip key={tag.tag_group_id} variant="outlined" sx={{ borderColor: tag.tag_group_color, backgroundColor: tag.tag_group_color, color: `${hexToGrayscale(tag.tag_group_color) > 150 ? "rgba(0, 0, 0, 0.87)" : "#FFFFFF"}` }} size={"small"} label={tag?.tag_name ?? ""} />)}
        //             </Stack>
        //         );
        //     },
        //     groupingValueGetter: (value, row, column, apiRef) => {
        //         return row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.task_category)?.[0]?.tag_name ?? "";
        //     },
        //     disableColumnMenu: true,
        //     sortable: false,
        // },
        // {
        //     field: 'Priority', headerName: 'Priority', width: 150,
        //     valueGetter: (value, row, column, apiRef) => { return row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.task_priority)?.[0]?.tag_name ?? "" },
        //     renderCell: (params: GridRenderCellParams) => {
        //         if (params.rowNode.type === 'group') {
        //             if (params.rowNode.groupingField === 'Priority') {
        //                 return params.rowNode.groupingKey;
        //             }
        //             return '';
        //         }
        //         return (
        //             <Stack
        //                 spacing={1}
        //                 direction={"row"}
        //                 id={"tagsChip"}
        //                 sx={{
        //                     width: "100%",
        //                 }}>
        //                 {params.row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.task_priority).map((tag: any) => <Chip key={tag.tag_group_id} variant="outlined" sx={{ borderColor: tag.tag_group_color, backgroundColor: tag.tag_group_color, color: `${hexToGrayscale(tag.tag_group_color) > 150 ? "rgba(0, 0, 0, 0.87)" : "#FFFFFF"}` }} size={"small"} label={tag?.tag_name ?? ""} />)}
        //             </Stack>
        //         );
        //     },
        //     groupingValueGetter: (value, row, column, apiRef) => {
        //         return row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.task_priority)?.[0]?.tag_name ?? "";
        //     },
        //     disableColumnMenu: true,
        //     sortable: false,
        // },
        { field: 'created_user', headerName: 'Created By', width: 150 },
        {
            field: 'created_time', headerName: 'Created Date', width: 250, renderCell: (params: GridRenderCellParams) => {
                if (params.rowNode.type === 'group') {
                    return params.value;
                }
                return <Typography variant="body2">{moment(params.row.created_time).format('lll')}</Typography>
            }
        },
        { field: 'modified_user', headerName: 'Last modified by', width: 150 },
        {
            field: 'modified_time', headerName: 'Last modified date', width: 250, renderCell: (params: GridRenderCellParams) => {
                if (params.rowNode.type === 'group') {
                    return params.value;
                }
                return <Typography variant="body2">{params.row.modified_time ? moment(params.row.modified_time).format('lll') : ""}</Typography>
            }
        },
        {
            field: 'delete', headerName: 'Delete', width: 100, renderCell: (params: GridRenderCellParams) => {
                return <IconButton onClick={() => onDelete(params.row)}>
                    <DeleteOutline color="error" id="delete-task" />
                </IconButton>
            },
            disableColumnMenu: true,
            sortable: false,
        },
    ];

    if (hideDelete) {
        columns.pop();
    }

    return columns
};